module.exports = __webpack_public_path__ + "6c2a7a0760aaf8096e4ffdcd53904ed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/pic1.jpg
// module id = 271
// module chunks = 0